import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import HeroCarousel from './components/HeroCarousel';
import Stats from './components/Stats';
import Solutions from './components/Solutions';
import ServiceSegments from './components/ServiceSegments';
import FeatureShowcase from './components/FeatureShowcase';
import VideoSection from './components/VideoSection';
import BrandsMarquee from './components/BrandsMarquee';
import Marketplaces from './components/Marketplaces';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';
import ChatWidget from './components/ChatWidget';

import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import MarketplacesPage from './pages/MarketplacesPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactPage from './pages/ContactPage';
import PricingPage from './pages/PricingPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import { CartProvider } from './context/CartContext';
import CartDrawer from './components/CartDrawer';

function HomePage() {
  return (
    <>
      <HeroCarousel />
      <Stats />
      <Solutions />
      <ServiceSegments />
      <VideoSection />
      <FeatureShowcase />
      <BrandsMarquee />
      <Marketplaces />
      <WhyUs />
      <Testimonials />
      <FAQ />
      <Contact />
    </>
  );
}

function Layout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <FloatingActions />
      <ChatWidget />
      <CartDrawer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/marketplaces" element={<MarketplacesPage />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/payment-success" element={<CheckoutSuccessPage />} />
            </Routes>
          </Layout>
        </CartProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
